import { useEffect, useRef, useState } from 'react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

// Thin YouTube/GitHub-style loading bar pinned to the top of the viewport.
// It shows whenever a React-Query request or mutation is in flight — which
// also covers page navigations, since each route fetches its data. The bar
// trickles up toward ~92% while busy, then snaps to 100% and fades out.
export default function TopProgressBar() {
  const busy = useIsFetching() + useIsMutating() > 0;
  const [progress, setProgress] = useState(0);   // 0 = hidden
  const tick = useRef(0);

  useEffect(() => {
    clearInterval(tick.current);
    if (busy) {
      setProgress((p) => (p < 8 ? 8 : p));                    // appear immediately
      tick.current = setInterval(() => {
        setProgress((p) => (p >= 92 ? p : p + (92 - p) * 0.14)); // ease toward 92%
      }, 180);
      return () => clearInterval(tick.current);
    }
    // finished: complete the bar, then reset (which unmounts it)
    setProgress((p) => (p > 0 ? 100 : 0));
    const done = setTimeout(() => setProgress(0), 420);
    return () => clearTimeout(done);
  }, [busy]);

  if (progress === 0) return null;
  return (
    <div
      className="top-progress"
      data-done={progress >= 100 ? 'true' : undefined}
      style={{ width: `${progress}%` }}
      role="progressbar"
      aria-hidden="true"
    />
  );
}
